import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type TrailerClipsFragment = {
	__typename?: 'Clip';
	sourceUrl: string;
	externalId: string;
	provider: Types.ClipProvider;
	name: string;
	sources: { __typename?: 'Sources'; dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null };
};

export const TrailerClipsFragmentDoc = gql`
	fragment TrailerClips on Clip {
		sourceUrl
		externalId
		provider
		name
		sources {
			dynamicManifest {
				fileGroupId
			}
		}
	}
`;
